export default {
  categories: {
    list_of_categories: 'List of categories',
    topic: 'Topic',
    topic_code: 'Topic Code',
    topicCode: 'Topic Code',
    parentCategory: 'Parent Category',
    noParent: 'No Parent',
    create_a_new_category: 'Create a new category',
    edit_category: 'Edit Category',
    confirm_remove_category: 'Confirm category deletion?',
    categories_management: 'Categories Management',
    search_placeholder: 'Search categories...',
    no_results: 'No results found',
    no_categories: 'No categories found',
    parent: 'Parent',
    confirm_delete: 'Confirm Delete',
    delete_success: 'Category deleted successfully',
    delete_error: 'Error deleting category',
    create_success: 'Category created successfully',
    create_error: 'Error creating category',
    update_success: 'Category updated successfully',
    update_error: 'Error updating category',
    save_error: 'Error saving category',
    add_category: 'Add Category',
    enter_topic: 'Enter topic',
    enter_topic_code: 'Enter topic code',
    select_parent: 'Select parent category',
    no_parent: 'No Parent',
    label: 'Label',
    label_english: 'Label (English)',
    code: 'Code',
    filter: 'Filter',
    parent_category: 'Parent Category',
    category: 'Category',
    edit_universe_category: 'Edit Universe Category',
    add_universe_category: 'Add Universe Category',
    create_a_new_universe_category: 'Create a new Universe category',
    universe_categories_management: 'Universe Categories Management',
    create_a_new_subcategory: 'Create a new Subcategory',
    subcategories_management: 'Sub-Categories Management',
    edit_subcategory: 'Edit Sub-Category',
    create: 'Create',
    select_parent_category: 'Select Parent Category',
    type: 'Type',
    template_preview: 'Template Preview',
    template_one: 'Template One',
    template_two: 'Template Two',
    template_three: 'Template Three',
    select_category: 'Select Category',
    one_or_more_categories: 'One or more category(ies)',
    import_excel: 'Import from Excel',
    import_template: 'Download template',
    import_loading: 'Importing…',
    import_done: 'Import completed',
    import_universes: 'Universes',
    import_categories: 'Categories',
    import_subcategories: 'Subcategories',
    import_created: 'created',
    import_existing: 'already existing',
    import_errors: 'Errors found, nothing was imported',
    import_row: 'Row',
    import_select_file: 'Please select an .xlsx or .xls file',
    import_close: 'Close',
  },
};
